import { render } from "./MfPriceInput.vue?vue&type=template&id=aefa3888"
import script from "./MfPriceInput.vue?vue&type=script&lang=js"
export * from "./MfPriceInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__